import React from "react";
import {FontAwesomeIconData} from "../../data/Icons/FortAwesomeData";

export const FontAwesomeIconProvider = {
    getFontAwesomeIconData,
    getFontAwesomeIconItem,
};

function getFontAwesomeIconData(){
    return FontAwesomeIconData.map((iconData, index) => {
        const { id, value, name } = iconData
        return (
            {
                id: id,
                value: name,
                label: <div><span className={value} /><span>    </span><label>{name}</label></div>}
        )
    });
}

function getFontAwesomeIconItem(id){
    const index = FontAwesomeIconData.findIndex(n => n.id === id);

    if (index === -1){
        return;
    }

    return (
        {
            id: FontAwesomeIconData[index].id,
            value: FontAwesomeIconData[index].name,
            label: <div><span className={FontAwesomeIconData[index].value} /><span>    </span><label>{FontAwesomeIconData[index].name}</label></div>}
    )
}